import DatePickerRange from './DatePickerRange';


export default DatePickerRange;
export {
	DatePickerRange
};